import axios from "../../../../../axios";
import React from "react";
import "./openThreeDotPopup.css";
import PopupMenu from "../../../../../Components/PopupMenuThreeDot";
import BlockIcon from "@mui/icons-material/Block";

const OpenThreeDotPopup = ({ publishedActivity_id, isDeactivated }) => {
  const handleStatus = async (e) => {
    e.preventDefault();

    const changeStatus = { status: "draft" };

    try {
      const res = await axios.post(
        `/api/v1/homework/activity/updateStatus/${publishedActivity_id}`,
        changeStatus
      );

      if (res) {
        isDeactivated?.(); // Refetch from parent
      }
    } catch (error) {
      console.log(error);
    }
  };

  const actions = [
    {
      label: "Deactivate",
      onClick: handleStatus,
      color: "error",
      icon: <BlockIcon />,
    },
  ];

  return <PopupMenu actions={actions} />;
};

export default OpenThreeDotPopup;
